import cn from 'classnames';
import { useHistory } from 'react-router';
import { useEvalSubscription } from './hooks/userEvalSubscription';
import { Pluralize } from '../common/Pluralize';
import { appConfig } from '../../app-config';
import { LocationStateBuilder, PopupType } from '../../types/state/ui/LocationState';
import IconSVG from '../../styles/svg-icons';

const subscriptionRemainingDaysMax = 14

interface Props {
    disabled?: boolean;
}
export function EvalSubscriptionBanner({ disabled = false }: Props) {
    const history = useHistory();

    const { isTrial, isTrialEnded, trialPeriodDays, isSubscriptionEnded, subscriptionRemainingDays } = useEvalSubscription();

    const isSubscriptionEndedSoon =
        !isTrial &&
        !isSubscriptionEnded &&
        subscriptionRemainingDays >= 7 &&
        subscriptionRemainingDaysMax <= 14;

    const isSubscriptionEndedInWeek =
        !isTrial &&
        !isSubscriptionEnded &&
        subscriptionRemainingDays > 1 &&
        subscriptionRemainingDays < 7;

    if (
        !isTrial &&
        !isTrialEnded &&
        subscriptionRemainingDays > subscriptionRemainingDaysMax
    ) {
        return null;
    }

    function handleTryEvalClick() {
        history.push({
            ...history.location,
            state: new LocationStateBuilder()
                .popup(PopupType.EvalTrial)
                .result(),
        });
    }

    function expiring(days: number) {
        if (days === 0) return <b>expired</b>
        if (days === 1) return <>is expiring <b>today</b></>;
        return <>will be ending in <b><Pluralize count={days} singular="day" /></b></>
    }

    function contactSales() {
        return <>Contact <a href={`mailto:${appConfig.salesEmail}`}>{appConfig.salesEmail}</a> to keep unlimited access.</>
    }

    return (
        <div className={cn('banner trial-period-banner', {
            'request-trial': !isTrial && !isTrialEnded && !isSubscriptionEnded && !subscriptionRemainingDays, // Trial has not started yet
            'trial-active': isTrial && !isTrialEnded && trialPeriodDays > 1,
            'trial-last-day': isTrial && !isTrialEnded && trialPeriodDays === 1, // Trial last day
            'trial-ended': isTrialEnded, // Trial ended
            'eval-paid-ended-soon': isSubscriptionEndedSoon, // Paid subscription ends in 7-14 days
            'eval-paid-ended-last-week': isSubscriptionEndedInWeek,
            'eval-paid-last-day': subscriptionRemainingDays === 1, // Paid subscription last day
            'eval-paid-ended': isSubscriptionEnded // Paid subscription ended
        })}>
            <span>
                {!isTrial && !isTrialEnded && !isSubscriptionEnded && !subscriptionRemainingDays && // Trial has not started yet
                    <>
                        <IconSVG name="info" width="16" height="16" />
                        Start your free EVAL™ trial today 
                        <button
                            disabled={disabled}
                            onClick={handleTryEvalClick}
                            className="btn btn-main btn-sm margin-l-8"
                        >
                            Try EVAL™
                        </button>
                    </>
                }
                {isTrial && !isTrialEnded &&
                    <>Your free trial of the EVAL™ {expiring(trialPeriodDays)}. {contactSales()}</>
                }
                {isTrialEnded &&
                    <>Your free trial of the EVAL™ has {expiring(0)} and you switched to the Basic plan. {contactSales()}</>
                }
                {(isSubscriptionEndedSoon || isSubscriptionEndedInWeek || subscriptionRemainingDays === 1) &&
                    <>Your EVAL™ US BSL Full Universe plan {expiring(subscriptionRemainingDays)}. {contactSales()}</>
                }
                {isSubscriptionEnded &&
                    <>Your EVAL™ US BSL Full Universe plan has {expiring(0)} and you switched to the Basic plan. {contactSales()}</>
                }
            </span>
        </div>
    )
}